var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-wrapper outer-layout"},[_c('div',{staticClass:"footer-push login-screen"},[_c('div',{staticClass:"public-bg"}),_c('landing-navbar'),_c('router-view'),_c('landing-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }